import React from 'react';
import PropTypes from 'prop-types';
import Select from 'rc-select';
import Pagination from 'rc-pagination';
import th_TH from 'rc-pagination/lib/locale/th_TH';
import 'rc-pagination/assets/index.css';
import './css/Pagination.css';

class RCPagination extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: this.props.current,
            pageSize: this.props.pageSize,
        };
    }

//    componentWillReceiveProps(nextProps) {
//      const { isGroupOrder, currentPage, currentPageSize } = this.props;
//      console.log('currentPageSize RC:', currentPageSize);
//      if (nextProps.isGroupOrder !== isGroupOrder) {
//          this.setState({
//              current: currentPage,
//              pageSize: currentPageSize
//          })
//      }else if(!isGroupOrder && nextProps.currentPage!=this.props.currentPage){
//         this.setState({
//             current: nextProps.currentPage,
//             pageSize: nextProps.currentPageSize
//         })
//      }
//    }

  onChange = (page) => {
    this.props.onSelect(page);
    this.setState({
      current: page,
    });
  }

  onShowSizeChange = (current, pageSize) => {
    this.setState({ pageSize });
    this.props.onShowSizeChange(current, pageSize);
  }

  render() {
    const { total ,isSimple}=this.props;
    return (
        <div>
            <div className="d-none d-md-block" >
                <Pagination onChange={this.onChange} current={this.state.current} total={total} pageSize={this.state.pageSize}
                    simple = {isSimple}
                    selectComponentClass={Select}
                    showSizeChanger
                    locale={th_TH}
                    onShowSizeChange={this.onShowSizeChange}/>
            </div>
            <div className="d-block d-md-none" >
                <Pagination simple  onChange={this.onChange} current={this.state.current} total={total} pageSize={this.state.pageSize}
                    selectComponentClass={Select}
                    showSizeChanger
                    locale={th_TH}
                    onShowSizeChange={this.onShowSizeChange}/>
            </div>

        </div>
    )
  }
}

RCPagination.propTypes = {
    current: PropTypes.number,
    total: PropTypes.number.isRequired,
    pageSize: PropTypes.number,
    isGroupOrder: PropTypes.bool,
    currentPage: PropTypes.number,
    currentPageSize: PropTypes.number,
    isSimple: PropTypes.bool
}

RCPagination.defaultProps = {
    current: 1,
    pageSize: 20,
    isGroupOrder: false,
    currentPage: 1,
    currentPageSize: 10,
    isSimple:false
}

export default RCPagination;



// WEBPACK FOOTER //
// ./src/app/view/components/UserControl/Pagination/RCPagination.js